module.exports = __webpack_public_path__ + "files/195c11980d196e2232f26fe9f122a4fd.png";